import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/attritionAndCancelReasonsSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const MembershipTypes = () => {
  const dispatch = useDispatch();

  const allOptions = useSelector(
    (state) => state.attritionAndCancelReasons.filters.membership_types
  );
  const selectedOptions = useSelector(
    (state) => state.attritionAndCancelReasons.selectedFilters.membership_types
  );

  const onSelectChange = (data) =>
    dispatch(actionCreators.updateFilter({ key: "membership_types", data }));

  return (
    <>
      <p>Membership Types</p>
      <MultiSelectDropdown
        options={allOptions}
        selectedFilters={selectedOptions}
        placeholder="Select Action"
        numberDisplayed={0}
        includeSelectAll
        enableOnly
        onSelectChange={onSelectChange}
      />
    </>
  );
};
